interface DisplacedNoticeProps {
  onUseHere: () => void;
}

/**
 * Shown when this Discord account opened DeltaTape on another screen (one live
 * screen per account — anti login-sharing). "Use DeltaTape here" reconnects,
 * which in turn bumps the other screen.
 */
export function DisplacedNotice({ onUseHere }: DisplacedNoticeProps): JSX.Element {
  return (
    <div className="displaced-notice" role="alert">
      <p className="displaced-notice__text">DeltaTape was opened on another device or window.</p>
      <button type="button" className="displaced-notice__btn" onClick={onUseHere}>
        Use DeltaTape here
      </button>
    </div>
  );
}
